import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div>
      <h1>404 — Página não encontrada</h1>
      <p>
        <Link to="/">Voltar para a página inicial</Link>
      </p>
    </div>
  );
}
